import {
  View,
  Text,
  StyleSheet,
  Image,
  Modal,
  ActivityIndicator,
  ScrollView,
  Dimensions,
  PixelRatio,
} from "react-native";
import React, { useEffect, useState } from "react";
import Colours from "../../utils/Colours";
import { TouchableOpacity } from "react-native";
import SupportIcon from "../../icons/SupportIcon";
import DoesIconn from "../../icons/DoesIconn";
import MoneyIcon from "../../icons/MoneyIcon";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import useAuth from "../../hooks/useAuth";
import ClockIcon from "../../icons/ClockIcon";
import TopHeaderComponent from "../aTopHeader/TopHeaderComponent";
import WalletTransactionHistory from "./WalletTransactionHistory";
import Toast from "react-native-toast-message";
import toastConfig from "../../toasts/toastConfig";
import CopyyIcon from "../../icons/CopyyIcon";
import * as Clipboard from "expo-clipboard";
import TransactionDigitCodeScreen from "../transactionDigitCode/TransactionDigitCodeScreen";

const { width, height } = Dimensions.get("window");
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

// const WalletBalanceScreen = ({ dvaDetails, isLoadings3, isLoading2, walletBalance }) => {
const WalletBalanceScreen = ({ setShowWalletBalanceScreen }) => {
  const [transactionCodeCorrect, setTransactCodeCorrect] = useState(false);
  const [useAvailableCredits, setUserAvailableCredit] = useState(true);
  const [showBodyTableCreditCategory, setShowBodyTableCreditCategory] = useState(false);
  const [showWalletTransactHistory, setShowWalletTransactHistory] = useState(false);
  const [showTransactionDigitCodeScreen, setShowTransactionDigitCodeScreen] = useState(false);
  const [isLoadings3, setIsLoadings3] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [dvaDetails, setDVADetails] = useState();
  const [walletBalance, setWalletBalance] = useState("");

  const axiosPrivate = useAxiosPrivate();

  const { email, isReverified, updateInteraction, reverifyUser } = useAuth();

  // useEffect(() => {
  //     if (transactionCodeCorrect) {
  //         reverifyUser();
  //         // optionally reset to false if you don’t want it to run multiple times
  //         setTransactCodeCorrect(false);
  //     }
  // }, [transactionCodeCorrect, reverifyUser]);

  useEffect(() => {
    fetchUserAccountDetails();
    fetchUserWalletBalance();
    // handleWalletScreen()
  }, []);

  // useEffect(() => {
  //     if (!isReverified) {
  //         //console.log('Timer is up, isReverified is now false.');

  //         //Launch a user reverification form modal
  //         setShowTransactionDigitCodeScreen(true)

  //     }
  // }, [isReverified])

  const fetchUserWalletBalance = async () => {
    setIsLoading2(true);
    //console.log('email', email)
    try {
      const response = await axiosPrivate.get("/walletBalance/userWalletBalance");

      //console.log('responsexxy', response.data)

      // Handle success response
      if (response.status === 200 || response.status === 201) {
        //console.log('Wallet Balance fetched:', response.data);

        setWalletBalance(response.data.walletBalance.toLocaleString());

        // Use response.data.customerId if needed for further processing
      } else {
        //console.error('Unexpected response:', response);
      }
    } catch (error) {
      if (error.response) {
        //console.error('Error response from server:', error.response.data);
      } else if (error.request) {
        //console.error('No response received:', error.request);
      } else {
        //console.error('Error setting up the request:', error.message);
      }
    } finally {
      setIsLoading2(false);
    }
  };

  const fetchUserAccountDetails = async () => {
    setIsLoadings3(true);
    //console.log('email', email)
    try {
      // Make the axios POST request to the backend
      const response = await axiosPrivate.get(`/getUserDVA/dvaDetails/${email}`);

      //console.log('responsexx', response.data)

      // Handle success response
      if (response.status === 200 || response.status === 201) {
        //console.log('meeza credit fetched:', response.data);

        setDVADetails(response.data);

        // Use response.data.customerId if needed for further processing
      } else {
        //console.error('Unexpected response:', response);
      }
    } catch (error) {
      if (error.response) {
        //console.error('Error response from server:', error.response.data);
      } else if (error.request) {
        //console.error('No response received:', error.request);
      } else {
        //console.error('Error setting up the request:', error.message);
      }
    } finally {
      setIsLoadings3(false);
    }
  };

  const handleMeezaCredits = () => {
    setUserAvailableCredit(false);
    setShowBodyTableCreditCategory(true);
  };
  const handleViewWalletTransactionHistory = () => {
    setShowWalletTransactHistory(true);
  };

  return (
    <View style={styles.walletContainer}>
      <View style={styles.walletSubContainer}>
        <Text style={styles.balanceTxt}>BALANCE</Text>
        <View style={styles.balance}>
          <Text style={styles.ngnTxt}>NGN</Text>
          {isLoading2 ? (
            <ActivityIndicator size="large" color={Colours.PRIMARY} />
          ) : (
            <Text style={styles.walletBalanceTxt}>{walletBalance}</Text>
          )}
        </View>
        <Text style={styles.topUpTxt}>TO FUND YOUR WALLET</Text>
        {isLoadings3 ? (
          <ActivityIndicator size="large" color={Colours.PRIMARY} />
        ) : (
          <View style={styles.accountDetails}>
            <Text style={styles.transferToTxt}>TRANSFER TO</Text>
            <View style={{ display: "flex", flexDirection: "row", gap: 5 }}>
              <Text style={styles.bankTxt}>BANK</Text>
              <Text selectable style={styles.dvaDetailsTxt}>
                {dvaDetails?.customerDvaDetails?.[0]?.bank?.name?.toUpperCase()}
              </Text>
            </View>
            <View style={{ display: "flex", flexDirection: "row", gap: 5 }}>
              <Text style={styles.accountNumberLabelTxt}>ACCOUNT NUMBER</Text>
              <Text selectable style={styles.accountNumberTxt}>
                {dvaDetails?.customerDvaDetails?.[0]?.account_number}
              </Text>
              <TouchableOpacity
                onPress={() => {
                  const accountNumber = dvaDetails?.customerDvaDetails?.[0]?.account_number;
                  // updateInteraction()
                  if (accountNumber) {
                    Clipboard.setStringAsync(accountNumber);
                    // Alert.alert('Copied!', 'Account number copied to clipboard.');
                    Toast.show({
                      type: "success",
                      text1: "Copied to clipboard",
                      text2: "Account number has been copied.",
                      // position: 'bottom',
                      visibilityTime: 2000,
                    });
                  }
                }}
              >
                <CopyyIcon
                  color={Colours.PRIMARY}
                  height={dynamicSize(24)}
                  width={dynamicSize(24)}
                />
              </TouchableOpacity>
            </View>
            <View style={{ display: "flex", flexDirection: "row", gap: 5 }}>
              <Text style={styles.accountNameLabelTxt}>ACCOUNT NAME</Text>
              <Text selectable style={styles.accountNameTxt}>
                {dvaDetails?.customerDvaDetails?.[0]?.account_name}
              </Text>
            </View>
          </View>
        )}
      </View>

      <View style={styles.dataContainer}>
        <View style={styles.dataSubContainer2}>
          <DoesIconn color={Colours.PRIMARY} height={dynamicSize(25)} width={dynamicSize(25)} />
          <View style={styles.captionAndDescribtion}>
            <View style={styles.flatArrowContainer}>
              <Text style={styles.joinDoingsTxt}>Join the Doings Trend</Text>
              {/* <FowardFlatArrow color={Colours.PRIMARY} /> */}
            </View>
            <Text style={styles.letPeopleSeeTxt}>Let People see your Doings</Text>
          </View>
        </View>

        <TouchableOpacity
          style={styles.dataContainer2}
          onPress={() => {
            //updateInteraction()
            handleMeezaCredits();
          }}
        >
          <View style={styles.dataSubContainer}>
            <MoneyIcon color={Colours.PRIMARY} height={dynamicSize(25)} width={dynamicSize(25)} />
            <View style={styles.captionAndDescribtion}>
              <View style={styles.flatArrowContainer}>
                <Text style={styles.buyMeezaTxt}>Buy Meeza Credits </Text>
                {/* <FowardFlatArrow color={Colours.PRIMARY} /> */}
              </View>
              <Text style={styles.doingsDescribeTxt}>
                You can only join the doings trend by purchasing meeza credits. Spend more meeza
                credits and watch your profile or table move up the doings trend
              </Text>
            </View>
          </View>
        </TouchableOpacity>
      </View>

      <View style={styles.dataContainer3} onPress={() => {}}>
        <TouchableOpacity
          style={styles.dataContainer2}
          onPress={() => {
            // updateInteraction()
            handleViewWalletTransactionHistory();
          }}
        >
          <View style={styles.dataSubContainer}>
            <ClockIcon color={Colours.PRIMARY} width={dynamicSize(25)} height={dynamicSize(25)} />
            <View style={styles.captionAndDescribtion}>
              <View style={styles.flatArrowContainer}>
                <Text style={styles.walletTransactionHistoryTxt}>Wallet Transaction History </Text>
                {/* <FowardFlatArrow color={Colours.PRIMARY} /> */}
              </View>
              {/* <Text style={{ width: 250, color: Colours.DARKLIGHTGRAY, fontSize: 13, fontFamily: 'Sen-Regular' }}>You can only join the doingz trend by purchasing meeza credits. Spend more meeza credits and watch your profile or table move up the doingz trend</Text> */}
            </View>
          </View>
        </TouchableOpacity>
      </View>

      <Modal
        animationType="slide"
        visible={showWalletTransactHistory}
        onRequestClose={() => setShowWalletTransactHistory(false)}
      >
        <TopHeaderComponent
          headerText={"Wallet Transaction History"}
          hideScreen={() => setShowWalletTransactHistory(false)}
        />
        <ScrollView
          style={styles.componentStyle}
          contentContainerStyle={{
            flexGrow: 1,
            paddingBottom: 100,
            backgroundColor: Colours.LIGHTEST,
          }}
        >
          <WalletTransactionHistory />
        </ScrollView>
      </Modal>

      {/* <Modal
                animationType='slide'
                visible={showTransactionDigitCodeScreen}
                onRequestClose={() => {
                    setShowTransactionDigitCodeScreen(false)
                    setShowWalletBalanceScreen(false)

                }}
            >
                <TopHeaderComponent headerText={'Verify it is you'} hideScreen={() => {
                    setShowTransactionDigitCodeScreen(false)
                    setShowWalletBalanceScreen(false)
                }} />
                <ScrollView
                    style={styles.componentStyle}
                    contentContainerStyle={{ flexGrow: 1, paddingBottom: 100, backgroundColor: Colours.LIGHTEST }}>
                    <TransactionDigitCodeScreen
                        hideScreen={() => setShowTransactionDigitCodeScreen(false)}
                        setTransactCodeCorrect={setTransactCodeCorrect}
                    />
                </ScrollView>

            </Modal> */}

      <Toast config={toastConfig} />
    </View>
  );
};

const styles = StyleSheet.create({
  walletContainer: {
    display: "flex",
  },
  componentStyle: {
    backgroundColor: Colours.LIGHTEST,
    height: "100%",
  },
  balanceTxt: {
    marginTop: dynamicSpacing(15),
    color: Colours.PRIMARY,
    fontSize: dynamicFontSize(12),
    fontFamily: "Sen-Bold",
  },
  walletBalanceTxt: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(30),
    fontFamily: "Sen-Bold",
    textAlign: "center",
  },
  ngnTxt: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Bold",
  },
  topUpTxt: {
    marginTop: dynamicSpacing(15),
    marginBottom: dynamicSpacing(8),
    color: Colours.PRIMARY,
    fontSize: dynamicFontSize(12),
    fontFamily: "Sen-Bold",
  },
  transferToTxt: {
    marginBottom: dynamicSpacing(10),
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(12),
    fontFamily: "Sen-Bold",
  },
  bankTxt: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(12),
    fontFamily: "Sen-Regular",
  },
  dvaDetailsTxt: {
    color: Colours.PRIMARY,
    fontSize: dynamicFontSize(12),
    fontFamily: "Sen-Medium",
    width: "60%",
  },
  accountNumberLabelTxt: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(12),
    fontFamily: "Sen-Regular",
  },
  accountNumberTxt: {
    color: Colours.PRIMARY,
    fontSize: dynamicFontSize(14),
    fontFamily: "Sen-Bold",
  },
  accountNameLabelTxt: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(12),
    fontFamily: "Sen-Regular",
  },
  accountNameTxt: {
    color: Colours.PRIMARY,
    fontSize: dynamicFontSize(12),
    fontFamily: "Sen-Medium",
    width: "60%",
  },
  joinDoingsTxt: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Bold",
  },
  letPeopleSeeTxt: {
    width: dynamicSize(260),
    color: Colours.DARKLIGHTGRAY,
    fontSize: dynamicFontSize(13),
    fontFamily: "Sen-Regular",
  },
  buyMeezaTxt: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Regular",
  },
  doingsDescribeTxt: {
    width: dynamicSize(250),
    color: Colours.DARKLIGHTGRAY,
    fontSize: dynamicFontSize(13),
    fontFamily: "Sen-Regular",
  },
  walletTransactionHistoryTxt: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Regular",
  },
  walletSubContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: dynamicSpacing(7),
    padding: dynamicSpacing(15),
    borderBottomRightRadius: dynamicSize(30),
    borderBottomLeftRadius: dynamicSize(30),
    backgroundColor: Colours.PRIMARY_LIGHTER,
  },
  moneyWalletContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: dynamicSpacing(5),
  },
  balance: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: dynamicSpacing(5),
  },
  buttonSubContainer: {
    margin: dynamicSpacing(10),
    marginTop: dynamicSpacing(15),
    marginBottom: dynamicSpacing(3),
    padding: dynamicSpacing(15),
    borderRadius: dynamicSize(15),
    backgroundColor: "white",
    shadowColor: "#E8E8E8",
  },
  accountDetails: {
    display: "flex",
    borderRadius: dynamicSize(15),
    padding: dynamicSpacing(15),
    gap: dynamicSpacing(8),
    backgroundColor: "white",
    width: "100%",
  },
  buttonGray: {
    display: "flex",
    borderRadius: dynamicSize(10),
    justifyContent: "center",
    marginTop: dynamicSpacing(5),
    marginBottom: dynamicSpacing(5),
    alignItems: "center",
    height: dynamicSize(55),
    width: "100%",
    backgroundColor: Colours.DARKGRAY,
  },
  dataSubContainer2: {
    display: "flex",
    flexDirection: "row",
    gap: dynamicSpacing(10),
    alignItems: "center",
    marginBottom: dynamicSpacing(10),
  },
  dataContainer: {
    display: "flex",
    backgroundColor: "white",
    margin: dynamicSpacing(10),
    marginTop: dynamicSpacing(15),
    padding: dynamicSpacing(15),
    borderRadius: dynamicSize(10),
    marginBottom: dynamicSpacing(5),
  },
  dataContainer2: {
    display: "flex",
    borderWidth: 1,
    borderColor: Colours.PRIMARY_LIGHTER,
    padding: dynamicSpacing(15),
    borderRadius: dynamicSize(10),
    marginBottom: dynamicSpacing(10),
  },
  dataContainer3: {
    display: "flex",
    backgroundColor: "white",
    margin: dynamicSpacing(10),
    padding: dynamicSpacing(15),
    borderRadius: dynamicSize(10),
    marginBottom: dynamicSpacing(10),
  },
  dataSubContainer: {
    display: "flex",
    flexDirection: "row",
    gap: dynamicSpacing(10),
    alignItems: "center",
  },
  flatArrowContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: dynamicSize(260),
    marginBottom: dynamicSpacing(5),
  },
  captionAndDescribtion: {
    display: "flex",
  },
});

export default WalletBalanceScreen;
